import React from 'react';
const RankingsTable = () => {
  const rankings = [{
    position: 1,
    team: {
      name: 'Boston Celtics',
      logo: 'https://content.sportslogos.net/logos/6/213/thumbs/slhg02hbef3j1ov4lsnwyol5o.gif'
    },
    points: 48,
    total: {
      matches: {
        played: 26,
        won: 24,
        lost: 2
      },
      points: {
        scored: 2340,
        conceded: 1950,
        difference: 390
      },
      medium: {
        scored: 90.0,
        conceded: 75.0
      }
    },
    internal: {
      matches: {
        played: 13,
        won: 12,
        lost: 1
      },
      points: {
        scored: 1170,
        conceded: 962,
        difference: 208
      },
      medium: {
        scored: 90.0,
        conceded: 74.0
      }
    },
    external: {
      matches: {
        played: 13,
        won: 12,
        lost: 1
      },
      points: {
        scored: 1170,
        conceded: 988,
        difference: 182
      },
      medium: {
        scored: 90.0,
        conceded: 76.0
      }
    }
  }, {
    position: 2,
    team: {
      name: 'Milwaukee Bucks',
      logo: 'https://content.sportslogos.net/logos/6/225/thumbs/22582752016.gif'
    },
    points: 45,
    total: {
      matches: {
        played: 26,
        won: 22,
        lost: 4
      },
      points: {
        scored: 2262,
        conceded: 2054,
        difference: 208
      },
      medium: {
        scored: 87.0,
        conceded: 79.0
      }
    },
    internal: {
      matches: {
        played: 13,
        won: 11,
        lost: 2
      },
      points: {
        scored: 1131,
        conceded: 1014,
        difference: 117
      },
      medium: {
        scored: 87.0,
        conceded: 78.0
      }
    },
    external: {
      matches: {
        played: 13,
        won: 11,
        lost: 2
      },
      points: {
        scored: 1131,
        conceded: 1040,
        difference: 91
      },
      medium: {
        scored: 87.0,
        conceded: 80.0
      }
    }
  }, {
    position: 3,
    team: {
      name: 'New York Knicks',
      logo: 'https://content.sportslogos.net/logos/6/216/thumbs/2nn48xofg0hms8k326cqdmuis.gif'
    },
    points: 42,
    total: {
      matches: {
        played: 26,
        won: 21,
        lost: 5
      },
      points: {
        scored: 2184,
        conceded: 1989,
        difference: 195
      },
      medium: {
        scored: 84.0,
        conceded: 76.5
      }
    },
    internal: {
      matches: {
        played: 13,
        won: 11,
        lost: 2
      },
      points: {
        scored: 1092,
        conceded: 978,
        difference: 114
      },
      medium: {
        scored: 84.0,
        conceded: 75.2
      }
    },
    external: {
      matches: {
        played: 13,
        won: 10,
        lost: 3
      },
      points: {
        scored: 1092,
        conceded: 1011,
        difference: 81
      },
      medium: {
        scored: 84.0,
        conceded: 77.8
      }
    }
  }, {
    position: 4,
    team: {
      name: 'Miami Heat',
      logo: 'https://content.sportslogos.net/logos/6/214/thumbs/burm5gh2wvjti3xhei5h16k8e.gif'
    },
    points: 40,
    total: {
      matches: {
        played: 26,
        won: 20,
        lost: 6
      },
      points: {
        scored: 2158,
        conceded: 2002,
        difference: 156
      },
      medium: {
        scored: 83.0,
        conceded: 77.0
      }
    },
    internal: {
      matches: {
        played: 13,
        won: 10,
        lost: 3
      },
      points: {
        scored: 1079,
        conceded: 988,
        difference: 91
      },
      medium: {
        scored: 83.0,
        conceded: 76.0
      }
    },
    external: {
      matches: {
        played: 13,
        won: 10,
        lost: 3
      },
      points: {
        scored: 1079,
        conceded: 1014,
        difference: 65
      },
      medium: {
        scored: 83.0,
        conceded: 78.0
      }
    }
  }, {
    position: 5,
    team: {
      name: 'Philadelphia 76ers',
      logo: 'https://content.sportslogos.net/logos/6/218/thumbs/21870342016.gif'
    },
    points: 38,
    total: {
      matches: {
        played: 26,
        won: 19,
        lost: 7
      },
      points: {
        scored: 2106,
        conceded: 1976,
        difference: 130
      },
      medium: {
        scored: 81.0,
        conceded: 76.0
      }
    },
    internal: {
      matches: {
        played: 13,
        won: 10,
        lost: 3
      },
      points: {
        scored: 1053,
        conceded: 975,
        difference: 78
      },
      medium: {
        scored: 81.0,
        conceded: 75.0
      }
    },
    external: {
      matches: {
        played: 13,
        won: 9,
        lost: 4
      },
      points: {
        scored: 1053,
        conceded: 1001,
        difference: 52
      },
      medium: {
        scored: 81.0,
        conceded: 77.0
      }
    }
  }, {
    position: 6,
    team: {
      name: 'Cleveland Cavaliers',
      logo: 'https://content.sportslogos.net/logos/6/222/thumbs/22269212018.gif'
    },
    points: 36,
    total: {
      matches: {
        played: 26,
        won: 18,
        lost: 8
      },
      points: {
        scored: 2080,
        conceded: 1989,
        difference: 91
      },
      medium: {
        scored: 80.0,
        conceded: 76.5
      }
    },
    internal: {
      matches: {
        played: 13,
        won: 9,
        lost: 4
      },
      points: {
        scored: 1040,
        conceded: 988,
        difference: 52
      },
      medium: {
        scored: 80.0,
        conceded: 76.0
      }
    },
    external: {
      matches: {
        played: 13,
        won: 9,
        lost: 4
      },
      points: {
        scored: 1040,
        conceded: 1001,
        difference: 39
      },
      medium: {
        scored: 80.0,
        conceded: 77.0
      }
    }
  }, {
    position: 7,
    team: {
      name: 'Orlando Magic',
      logo: 'https://content.sportslogos.net/logos/6/217/thumbs/wd9ic7qb1zgxeil97bc2g1lls.gif'
    },
    points: 34,
    total: {
      matches: {
        played: 26,
        won: 17,
        lost: 9
      },
      points: {
        scored: 2028,
        conceded: 1963,
        difference: 65
      },
      medium: {
        scored: 78.0,
        conceded: 75.5
      }
    },
    internal: {
      matches: {
        played: 13,
        won: 9,
        lost: 4
      },
      points: {
        scored: 1014,
        conceded: 975,
        difference: 39
      },
      medium: {
        scored: 78.0,
        conceded: 75.0
      }
    },
    external: {
      matches: {
        played: 13,
        won: 8,
        lost: 5
      },
      points: {
        scored: 1014,
        conceded: 988,
        difference: 26
      },
      medium: {
        scored: 78.0,
        conceded: 76.0
      }
    }
  }, {
    position: 8,
    team: {
      name: 'Indiana Pacers',
      logo: 'https://content.sportslogos.net/logos/6/224/thumbs/22448122018.gif'
    },
    points: 32,
    total: {
      matches: {
        played: 26,
        won: 16,
        lost: 10
      },
      points: {
        scored: 2002,
        conceded: 1989,
        difference: 13
      },
      medium: {
        scored: 77.0,
        conceded: 76.5
      }
    },
    internal: {
      matches: {
        played: 13,
        won: 8,
        lost: 5
      },
      points: {
        scored: 1001,
        conceded: 988,
        difference: 13
      },
      medium: {
        scored: 77.0,
        conceded: 76.0
      }
    },
    external: {
      matches: {
        played: 13,
        won: 8,
        lost: 5
      },
      points: {
        scored: 1001,
        conceded: 1001,
        difference: 0
      },
      medium: {
        scored: 77.0,
        conceded: 77.0
      }
    }
  }];
  return <div className="overflow-x-auto" data-id="element-772" data-mp="3uhiz48xqj7lz">
      <table className="min-w-full divide-y divide-gray-200" data-id="element-773" data-mp="3brc3if98b3e">
        <thead data-id="element-774" data-mp="3a6h5rp12q50">
          <tr data-id="element-775" data-mp="39o9lywx0phs">
            <th colSpan={3} data-id="element-776" data-mp="3rxmamuwji5wv"></th>
            {/* Total Section */}
            <th className="px-3 py-3 bg-gray-50 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" colSpan={8} data-id="element-777" data-mp="3rwur4ig7vymy">
              Total
            </th>
            {/* Internal Section */}
            <th className="px-3 py-3 bg-gray-50 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" colSpan={8} data-id="element-778" data-mp="3d0lqpdklbf8y">
              Internal
            </th>
            {/* External Section */}
            <th className="px-3 py-3 bg-gray-50 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" colSpan={8} data-id="element-779" data-mp="346qnib313yvy">
              External
            </th>
          </tr>
          {/* Sub-headers */}
          <tr className="bg-gray-50" data-id="element-780" data-mp="2pb0xm1uq31ly">
            <th colSpan={3} data-id="element-781" data-mp="2p9zlrv5vub36"></th>
            {/* Total Sub-headers */}
            <th className="px-2 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" colSpan={3} data-id="element-782" data-mp="2la8mt467conk">
              Matches
            </th>
            <th className="px-2 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" colSpan={3} data-id="element-783" data-mp="1mi1wyax0k5rb">
              Points
            </th>
            <th className="px-2 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" colSpan={2} data-id="element-784" data-mp="1w9xv1lz3nvvj">
              Medium
            </th>
            {/* Internal Sub-headers */}
            <th className="px-2 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" colSpan={3} data-id="element-785" data-mp="13mk547ttk0kx">
              Matches
            </th>
            <th className="px-2 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" colSpan={3} data-id="element-786" data-mp="1dkrk4l4js8ka">
              Points
            </th>
            <th className="px-2 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" colSpan={2} data-id="element-787" data-mp="2ozwm1mwuu32u">
              Medium
            </th>
            {/* External Sub-headers */}
            <th className="px-2 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" colSpan={3} data-id="element-788" data-mp="2mjoqj0xxnrwz">
              Matches
            </th>
            <th className="px-2 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" colSpan={3} data-id="element-789" data-mp="3f8lzuek62edl">
              Points
            </th>
            <th className="px-2 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" colSpan={2} data-id="element-790" data-mp="35gq1r3i2yo9d">
              Medium
            </th>
          </tr>
          {/* Detail headers */}
          <tr className="bg-gray-50 text-xs text-gray-500" data-id="element-791" data-mp="1z7uax67zj9h">
            <th className="px-1 py-1 text-left font-medium uppercase" data-id="element-792" data-mp="6sj1x0iuw42g">Pos</th>
            <th className="px-1 py-1 text-left font-medium uppercase" data-id="element-793" data-mp="gnzqu301kpu3">Team</th>
            <th className="px-1 py-1 text-center font-medium uppercase" data-id="element-794" data-mp="bowl0gc8mfl2">Pts</th>
            {/* Total Details */}
            <th className="px-1 py-1 text-center" data-id="element-795" data-mp="7mjp0jnalw1h">P</th>
            <th className="px-1 py-1 text-center" data-id="element-796" data-mp="7p5wyke3idk8">W</th>
            <th className="px-1 py-1 text-center" data-id="element-797" data-mp="2mx37ltef7h2">L</th>
            <th className="px-1 py-1 text-center" data-id="element-798" data-mp="2qb8p2xczwsq">S</th>
            <th className="px-1 py-1 text-center" data-id="element-799" data-mp="3tv1h5ezm7oou">C</th>
            <th className="px-1 py-1 text-center" data-id="element-800" data-mp="3p3t8il6407cq">D</th>
            <th className="px-1 py-1 text-center" data-id="element-801" data-mp="3p28d6tbz0kdt">S</th>
            <th className="px-1 py-1 text-center" data-id="element-802" data-mp="3k3yhmhmc3hro">C</th>
            {/* Internal Details */}
            <th className="px-1 py-1 text-center" data-id="element-803" data-mp="3g3el9g9l4i6l">P</th>
            <th className="px-1 py-1 text-center" data-id="element-804" data-mp="3g4pl54zwt5sf">W</th>
            <th className="px-1 py-1 text-center" data-id="element-805" data-mp="3b41oo3swvwqt">L</th>
            <th className="px-1 py-1 text-center" data-id="element-806" data-mp="3b5mifr7ejbnm">S</th>
            <th className="px-1 py-1 text-center" data-id="element-807" data-mp="365qgdxi9luap">C</th>
            <th className="px-1 py-1 text-center" data-id="element-808" data-mp="1lmmvjico44xq">D</th>
            <th className="px-1 py-1 text-center" data-id="element-809" data-mp="1lm4qpxbxwie7">S</th>
            <th className="px-1 py-1 text-center" data-id="element-810" data-mp="1ql7xpnbhcyot">C</th>
            {/* External Details */}
            <th className="px-1 py-1 text-center" data-id="element-811" data-mp="1vl3rktqgr9qn">P</th>
            <th className="px-1 py-1 text-center" data-id="element-812" data-mp="1vlluuabjmo82">W</th>
            <th className="px-1 py-1 text-center" data-id="element-813" data-mp="1zmxl8i28rdhb">L</th>
            <th className="px-1 py-1 text-center" data-id="element-814" data-mp="1zkbfmnywv81q">S</th>
            <th className="px-1 py-1 text-center" data-id="element-815" data-mp="12x7wtukgfrwi">C</th>
            <th className="px-1 py-1 text-center" data-id="element-816" data-mp="12uc0gao99ba6">D</th>
            <th className="px-1 py-1 text-center" data-id="element-817" data-mp="17w1bvrfe3qys">S</th>
            <th className="px-1 py-1 text-center" data-id="element-818" data-mp="1bx3d2dsvad3e">C</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200" data-id="element-819" data-mp="1bv0f97lh3fo4">
          {rankings.map(team => <tr key={team.position} className="hover:bg-gray-50" data-id="element-820" data-mp="k5ngps1idbzz">
              <td className="px-3 py-2 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-821" data-mp="k55kuwirczsl">
                {team.position}
              </td>
              <td className="px-3 py-2 whitespace-nowrap" data-id="element-822" data-mp="52dxhz2ghk9q">
                <div className="flex items-center" data-id="element-823" data-mp="52x4ikqkio8z">
                  <img src={team.team.logo} alt={team.team.name} className="w-6 h-6 mr-2" data-id="element-824" data-mp="42mhl0fd3px" />
                  <span className="text-sm font-medium text-gray-900" data-id="element-825" data-mp="a1qkqkx8otcu">
                    {team.team.name}
                  </span>
                </div>
              </td>
              <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-bold" data-id="element-826" data-mp="nraitdfvl2ft">
                {team.points}
              </td>
              {/* Total Stats */}
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-827" data-mp="xq9tt2o45a5z">
                {team.total.matches.played}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-828" data-mp="sq5e3ev14jgt">
                {team.total.matches.won}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-829" data-mp="2uk4o7wwf0urx">
                {team.total.matches.lost}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-830" data-mp="1a2c7jio6ef6l">
                {team.total.points.scored}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-831" data-mp="10c0qcufhe9hr">
                {team.total.points.conceded}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-832" data-mp="159j0go58iurc">
                {team.total.points.difference}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-833" data-mp="vco4od0cj8gr">
                {team.total.medium.scored}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-834" data-mp="hdwswx8yhyvs">
                {team.total.medium.conceded}
              </td>
              {/* Internal Stats */}
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-835" data-mp="2bqed1vyi0iw7">
                {team.internal.matches.played}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-836" data-mp="2gp7qjodsc9wd">
                {team.internal.matches.won}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-837" data-mp="2aa0gcq3bynlv">
                {team.internal.matches.lost}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-838" data-mp="25bfjn0naem26">
                {team.internal.points.scored}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-839" data-mp="2xzblskvml66c">
                {team.internal.points.conceded}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-840" data-mp="2t1jjqy19o3of">
                {team.internal.points.difference}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-841" data-mp="2o75nktes5sip">
                {team.internal.medium.scored}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-842" data-mp="3gqun8na04c69">
                {team.internal.medium.conceded}
              </td>
              {/* External Stats */}
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-843" data-mp="3k88pgvdwb39m">
                {team.external.matches.played}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-844" data-mp="3o9lrsvhs4obs">
                {team.external.matches.won}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-845" data-mp="21ucozrd4zct">
                {team.external.matches.lost}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-846" data-mp="70p3anvkns7h">
                {team.external.points.scored}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-847" data-mp="ftiiklb0qrlc">
                {team.external.points.conceded}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-848" data-mp="kractlz4ypsp">
                {team.external.points.difference}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-849" data-mp="uqsufvrkpzhl">
                {team.external.medium.scored}
              </td>
              <td className="px-1 py-2 whitespace-nowrap text-sm text-center" data-id="element-850" data-mp="1g0ophsw4l3lm">
                {team.external.medium.conceded}
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
};
export default RankingsTable;